<template>
  <div class="modal-container">
    <div class="modal-header">
      <h6>
        <span>
          <font-awesome-icon icon="info-circle" />
        </span>
        {{title}}
      </h6>
      <div class="close-modal">
          <span @click="$emit('close')">
            <font-awesome-icon icon="times" />
          </span>
      </div>
    </div>
    <div class="modal-body">
        <div class="modal-message">
            <p>
                {{text}}
                <a v-bind:href="`tel:${phone}`">{{phone}}</a>
                {{ betweenText }}
                <a v-bind:href="`mailto:${email}`">{{email}}</a>
            </p>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "warning-modal",
  props: {
    title: String,
    text: String,
    phone: String,
    betweenText: String,
    email: String
  }
};
</script>

<style lang="scss" scoped>
.modal-container {
  display: flex;
  flex-direction: column;
  z-index: 9999;
  width: 100%;
  height: 100%;
}

.modal-header {
  padding: 30px;
  background-color: #fdfdfd;
  border-bottom: 1px solid #f3f3f3;
  display: flex;
  justify-content: space-between;
  h6 {
    font-size: 1.5rem;
    font-weight: 600;

    span {
      display: inline-block;
      color: #efcc05;
      margin-right: 15px;
    }
  }
  .close-modal{
      span {
          cursor: pointer;
          color: #a0a0a0;
      }
  }
}

.modal-body{
    display: flex;
    align-items: center;
    padding: 30px;
    .modal-message {
        p{
            font-size: 13px;
        }
        a{
            font-size: 13px;
            &:hover{
                color: #0d7dbe;
                transition-duration: .2s;
            }
        }
    }
}

@include respond-below(sm){
    .modal-container {
        margin: 0 10px;
        .modal-header {
            padding: 15px;
            h6 {
                font-size: 1.2rem;

                span {
                margin-right: 10px;
                }
            }
        }
        .modal-body{
            display: flex;
            height: 100%;
            padding: 15px;
            .modal-message {
                p{
                    font-size: 12px;
                }
                a{
                    font-size: 12px;
                    &:hover{
                        color: #0d7dbe;
                        transition-duration: .2s;
                    }
                }
            }
        }
    }

}
</style>
